import FetchApi from "./api";
import config from "../config";

const serviceHome = {
	historyChat: async (pageNumber = "") => {
		// console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);
		const getTimezoneOffset = () => {
			const date = new Date();
			const utcDate = new Date(date.toLocaleString('en-US', { timeZone: "UTC" }));
			const tzDate = new Date(
				date.toLocaleString("en-US", {
					timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
					// timeZone: "Asia/Kolkata",
				})
			);

			return (tzDate - utcDate) / 3600000; // convert milliseconds to hours
		}
		// await fetch("https://api.ipify.org")
		// 	.then((response) => response.text())
		// 	.then((ip) => console.log(`The user's IP address is ${ip}.`))
		// 	.catch((error) => console.error(error));

		// async function getLocationByIP() {
		// 	return await fetch(`http://ip-api.com/json/172.104.207.20`)
		// 		.then((response) => response.json())
		// 		.then((data) => {
		// 			if (data.status === "success") {
		// 				return data;
		// 			} else {
		// 				throw new Error("Failed to retrieve location data");
		// 			}
		// 		})
		// 		.catch((error) => {
		// 			console.error("Error fetching location:", error);
		// 			return null; // or handle the error as needed
		// 		});
		// }
		// const getTimezone = await getLocationByIP();
		const timeDiff = getTimezoneOffset() * 60;

		return FetchApi(
			`${config.urls.apiBaseUrl}api/Account/currentUserQaByCharacter/${pageNumber}?timeZonedifferance=${timeDiff}`,
			"GET"
		);
	},
	getPromptContext: () =>
		FetchApi(`${config.urls.apiBaseUrl}api/Admin/GetPromptContext`, "GET"),
	getHistoryPrompt: () =>
		FetchApi(
			`${config.urls.apiBaseUrl}api/Admin/GetPromptContextHistory`,
			"GET"
		),
	getFullChatHistory: (params) =>
		FetchApi(
			`${config.urls.apiBaseUrl}api/Admin/GetPayload${params}`,
			"GET"
		),
	getLastChat: (params) =>
		FetchApi(
			`${config.urls.apiBaseUrl}api/Admin/GetLastPayload${params}`,
			"GET"
		),
	updatePromptContext: (payload) =>
		FetchApi(
			`${config.urls.apiBaseUrl}api/Admin/UpdatePromptContext`,
			"POST",
			payload
		),
};

export default serviceHome;
